<template>
  <div class="content pt-3">
    <b-container fluid>
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <b-row align-v="center">
              <b-col cols="7" lg="6">
                <h3 class="mb-0">Documentos Enviados</h3>
              </b-col>
              <b-col lg="6" cols="5" class="text-right">
                <base-button
                  v-show="insertFilestoIssuesRoles"
                  @click="handleClickButtonNewDocs"
                  size="sm"
                  type="neutral"
                  >Novo documento</base-button
                >
              </b-col>
            </b-row>
          </template>
          <div>
            <b-col
              cols="12"
              class="d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div>
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  placeholder="Buscar..."
                >
                </base-input>
              </div>
            </b-col>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
            >
              <el-table-column prop="details" label="Nome" min-width="140px">
              </el-table-column>
              <el-table-column
                prop="date"
                :formatter="
                  (row, col, cell, index) => this.formatDataLocaleString(cell)
                "
                label="Data"
                min-width="160px"
              >
              </el-table-column>
              <el-table-column min-width="170px" align="right" label="Status">
                <div slot-scope="{ $index, row }" class="d-flex">
                  <select
                    :disabled="!setFilesIssuesStatusRoles"
                    v-on:change="changeStatusItemList($event, row, $index)"
                    v-model="row.status"
                    class="form-control"
                  >
                    <option
                      v-for="option in selectOptionsStatus"
                      :key="option.id"
                      :label="option.status"
                      :value="option.id"
                    ></option>
                  </select>
                </div>
              </el-table-column>

              <el-table-column min-width="100px" align="right" label="Baixar">
                <div slot-scope="{ $index, row }" class="d-flex">
                  <base-button
                    @click="handleDownloadClickButton(row)"
                    class="edit"
                    type="primary"
                    size="sm"
                    icon
                  >
                    <i class="text-white ni ni-cloud-download-95"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Mostrando {{ from + 1 }} a {{ to }} de {{ total }} entries

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{ selectedRows.length }} linhas selecionadas
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              :current="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
              @change="paginationChanged($event)"
            >
            </base-pagination>
          </div>
        </card>

        <!-- modal- Form Docs -->

        <modal :show.sync="showDocForm">
          <h6 slot="header" class="modal-title">Enviar Documento</h6>
          <template>
            <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
              <form
                class="needs-validation pt-0"
                @submit.prevent="handleSubmit(firstFormSubmit)"
              >
                <div class="form-row">
                  <b-col md="12">
                    <base-input
                      label="Nome"
                      name="Nome"
                      placeholder="Identificação do arquivo"
                      rules="required"
                      v-model="formModal.docName"
                    >
                    </base-input>
                  </b-col>
                  <b-col md="12">
                    <base-input
                      label="Arquivo"
                      name="Arquivo"
                      placeholder="Identificação do arquivo"
                      rules="required"
                      ><b-form-file
                        accept=".jpg, .png, .pdf"
                        size="md"
                        id="example-input-2"
                        name="example-input-2"
                        browse-text="Anexar"
                        placeholder="Escolha um arquivo ou solte-o aqui ..."
                        v-model="formModal.docFile"
                        aria-describedby="input-2-live-feedback"
                      ></b-form-file>
                    </base-input>
                  </b-col>
                </div>
                <div class="text-right">
                  <base-button
                    type="link"
                    class="ml-auto"
                    @click="showDocForm = false"
                    >Fechar</base-button
                  >
                  <base-button
                    :disabled="disableSubmitButton"
                    type="primary"
                    native-type="submit"
                    >{{ submitButtonText }}</base-button
                  >
                </div>
              </form>
            </validation-observer>
          </template>
          <template slot="footer"><div></div></template>
        </modal>
      </div>
    </b-container>
  </div>
</template>

<script>
import FileInput from "@/components/Inputs/FileInput";
import DropzoneFileUpload from "@/components/Inputs/DropzoneFileUpload";
import swal from "sweetalert2";
import { Modal } from "@/components";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./../../Tables/PaginatedTables/clientPaginationMixin";
import bocapioService from "@/services/nodejs/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import { mapGetters } from "vuex";

export default {
  mixins: [clientPaginationMixin],
  components: {
    FileInput,
    DropzoneFileUpload,
    BasePagination,
    Modal,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  props: {
    idIssues: {
      type: Number
    }
  },
  data() {
    return {
      setFilesIssuesStatusRoles: null,
      insertFilestoIssuesRoles: null,
      showDocForm: false,
      submitButtonText: "Enviar",
      disableSubmitButton: false,
      formModal: {
        docName: "",
        docFile: null
      },
      tableData: [],
      selectOptionsStatus: [],
      propsToSearch: ["details", "date", "files_status.status"],
      selectedRows: []
    };
  },
  computed: {
    ...mapGetters([
      "roles"
      // ...
    ])
  },

  mounted() {
    this.getAllStatusRequerimentos();
    this.roles.issues ? this.getUserRoles() : "";
  },

  methods: {
    async firstFormSubmit() {
      this.submitButtonText = "Enviando...";
      this.disableSubmitButton = true
      const formData = new FormData();
      formData.append("file", this.formModal.docFile);
      const fileInfo = {
        name: this.formModal.docName,
        refId: this.idIssues,
        ref: 'issues',
        status: 1,
      }
      bocapioService
        .postDocumento(fileInfo, formData)
        .then(rsp => {
          console.log("resposta postDocumento", rsp.data);
          this.showDocForm = false;
          var document = rsp.data;
          this.submitButtonText = "Enviar";
          this.showSwal(
            "Sucesso!!",
            "Documento enviado com sucesso !!",
            "primary",
            "success"
          );
          this.formModal.docName = "";
          this.disableSubmitButton = false;
          this.formModal.docFile = null;
          this.addDocsTable(document);
        })
        .catch(error => {
          this.$router.push("/issues");
          this.disableSubmitButton = false;
          this.submitButtonText = "Enviar";
          this.showSwal(
            "Erro!!",
            "Algo deu errado. Tente novamente mais tarde !!",
            "warning",
            "warning"
          );
        });
    },
    addDocsTable(doc) {
      var CurrentIsoDate = new Date().toISOString();
      let docAux = {
        date: CurrentIsoDate,
        details: doc.details,
        files_status: {
          status: "pendente"
        },
        path: "",
        id: doc.id,
        status: doc.status
      };
      this.tableData.push(docAux);
    },

    handleClickButtonNewDocs() {
      this.formModal.docName = "";
      this.formModal.docFile = null;
      this.showDocForm = true;
    },

    getAllStatusRequerimentos() {
      bocapioService
        .getAllStatusRequerimentos()
        .then(rsp => {
          console.log("resposta getAllStatusRequerimentos ", rsp.data);
          this.selectOptionsStatus = rsp.data;
        })
        .finally(() => {
          this.getDocumentosByRequerimentoId();
        })
        .catch(erro => {
          console.log(erro);
          this.showSwal(
            "Erro!!",
            "Algo deu errado. Tente novamente mais tarde !!",
            "warning",
            "warning"
          );
        });
    },

    handleDownloadClickButton(row) {
      this.downloadDocumento(row);
    },

    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },

    changeStatusItemList(event, row, index) {
      if (event.target.options.selectedIndex > -1) {
        var id = event.target.value;
        var label =
          event.target.options[event.target.options.selectedIndex].label;
        this.tableData[index].files_status.status = label;

        bocapioService
          .updateStatusDocumento(row.id, id)
          .then(rsp => {
            console.log("Resposta updateStatusDocumento", rsp.data); //
            this.showSwal(
              "Sucesso!!",
              "Status de Documento atualizado com sucesso !!",
              "primary",
              "success"
            );
          })
          .catch(error => {
            this.$router.push("/issues");
            this.showSwal(
              "Erro!!",
              "Algo deu errado. Tente novamente mais tarde !!",
              "warning",
              "warning"
            );
          });
      }
    },

    getDocumentosByRequerimentoId() {
      bocapioService
        .getDocumentosByRequerimentoId(this.idIssues)
        .then(rsp => {
          console.log("resposta getDocumentosByRequerimentoId", rsp.data);
          this.tableData = rsp.data;
          this.createFuseSearch([
            "details",
            "issues_type.label",
            "date",
            "files_status.status"
          ]);
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    downloadDocumento(row) {
      if (row.id) {
        bocapioService
          .downloadDocumento(row.id)
          .then(rsp => {
            console.log("Resposta downloadDocumento", rsp.data);
            var blob = new Blob([rsp.data], { type: rsp.data.type });
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = row.details;
            link.click();
          })
          .catch(error => {
            alert(error);
          });
      }
    },

    filesChange(files) {
      this.formModal.docFile = files;
    },

    showSwal(title, text, btn, icon) {
      swal.fire({
        title: title,
        text: text,
        buttonsStyling: false,
        confirmButtonClass: `btn btn-${btn}`,
        icon: icon
      });
    },

    getUserRoles() {
      this.setFilesIssuesStatusRoles = this.roles.issues.find(
        role => role.action == "set_files_issues_status"
      );
      this.insertFilestoIssuesRoles = this.roles.issues.find(
        role => role.action == "insert_files_to_issues"
      );
    }
  }
};
</script>

<style></style>
